<template>
  <div 
  class="h-full w-full relative">
    <slot v-if="loaded"></slot>
  </div>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader"
export default {
  name: "VMapContext",
  props: {
    apiKey: String,
  },
  data() {
    return {
      context: {
        maps: null,
        geometry: null,
        marker: null,
      },
      loaded: false
    }
  },
  computed: {
    getContext(){
      return this.context;
    }
  },
  provide(){
    return this.getContext;
  },
  async mounted() {
    this.loader = new Loader({
      apiKey: this.apiKey,
      version: "weekly",
    });

    this.context.maps = await this.loader.importLibrary('maps');
    this.context.geometry = await this.loader.importLibrary("geometry");
    this.context.marker = await this.loader.importLibrary("marker");

    this.loaded = true;
  }
}
</script>

<style lang="scss" scoped></style>